module.exports = __webpack_public_path__ + "static/about-banner-3502ee4de0d34559441544fac457471f.jpg";